import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {query} from 'api';
import {SmallTitle, Link} from 'ui';
import {
  Container,
  Header,
  BackButton,
  Title,
  Slide,
  SlideImage,
  SlideText,
  SlideSubtitle,
  SubOffer,
  SubOfferHeader,
  SubOfferTitle,
  Badge,
  Grid,
  Product,
  ProductImage,
  ProductTitle,
  ProductSubtitle,
  Notion,
  Order,
  Mentions,
} from './styles';

const RELAIS_DOR_URL = 'https://www.relaisdor.fr/trouver-un-concessionnaire/';

// Catalogue de la page « produits » du site : bandeaux, puis offres > sous-offres > produits.
const Products = ({data, history}) => (
  <Container>
    <Header>
      <BackButton type="button" aria-label="Retour" onClick={() => history.goBack()} />
      <SmallTitle>Offres restauration &amp; glacier</SmallTitle>
      <Title>Nos produits</Title>
    </Header>

    {data.slides.map(slide => (
      <Slide key={slide.title}>
        {slide.image && <SlideImage src={slide.image} alt="" />}
        <SlideText>
          <SlideSubtitle>{slide.subtitle}</SlideSubtitle>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{__html: slide.caption}} />
        </SlideText>
      </Slide>
    ))}

    {data.offers.map(offer =>
      offer.sub_offers.map(subOffer => (
        <SubOffer key={subOffer.id}>
          <SubOfferHeader>
            <SubOfferTitle>
              {subOffer.title}
              {subOffer.detail && <span> {subOffer.detail}</span>}
            </SubOfferTitle>
            {subOffer.badge && <Badge src={subOffer.badge} alt="" />}
          </SubOfferHeader>
          <Grid>
            {subOffer.products.map(product => (
              <Product key={product.id}>
                {product.image && <ProductImage src={product.image} alt="" loading="lazy" />}
                <ProductTitle>{product.title}</ProductTitle>
                {product.subtitle && <ProductSubtitle>{product.subtitle}</ProductSubtitle>}
                {product.notion && <Notion>{product.notion}</Notion>}
              </Product>
            ))}
          </Grid>
        </SubOffer>
      )),
    )}

    <Order>
      <Link href={RELAIS_DOR_URL} target="_blank" rel="noopener noreferrer">
        Commandez tous les produits sur Relais d’Or Miko
      </Link>
    </Order>

    {/* eslint-disable-next-line react/no-danger */}
    {data.mentions && <Mentions dangerouslySetInnerHTML={{__html: data.mentions}} />}
    {/* eslint-disable-next-line react/no-danger */}
    {data.mentions_products && <Mentions dangerouslySetInnerHTML={{__html: data.mentions_products}} />}
  </Container>
);

Products.propTypes = {
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Products |> query('getProducts', {loadingFullWidth: true}) |> withRouter;
